/* eslint-disable no-console */

function clearCacheStorage (): Promise<void> {
  if (!('caches' in window)) {
    return Promise.resolve()
  }

  return window.caches.keys()
    .then(cacheNames => Promise.all(cacheNames.map(cacheName => window.caches.delete(cacheName))))
    .then(() => undefined)
}

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const hadController = Boolean(navigator.serviceWorker.controller)

    navigator.serviceWorker.getRegistrations()
      .then(registrations => Promise.all(registrations.map(registration => registration.unregister())))
      .then(() => clearCacheStorage())
      .then(() => {
        if (hadController) {
          window.location.reload()
        }
      })
      .catch(error => {
        console.error('Error clearing service worker cache:', error)
      })
  })
}
